.sort {
  path {
    fill: var(--ixf-text-tone-md);
  }

  .active {
    fill: var(--ixf-text-tone-md);
  }

  .inactive {
    fill: var(--ixf-color-neutral-md);
  }
}
